<template>
  <div class="AbroadOptionsForm">
    <h2 class="gl_form-title">
      {{ t('rater.health.abroad-options.form-legend') }}
    </h2>

    <RadioButtonGroup
      id="main"
      :value="abroadOption"
      :options="abroadOptions"
      v-model="abroadOption"
      :rules="[validationRules.radioRequired]"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
import { useRules } from '@/modules/core/composables/useRulesComposable'

defineExpose({ triggerSubmit })

interface PropsInterface {
  nextForm: String[]
  answers: Record<string, any>
  configurations: Record<string, any>
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const { t } = useI18n()
const { required } = useRules()

const validationRules = {
  radioRequired: (value: string) => required(value, 'common.validations.option')
}

const abroadOptions = ref(props.configurations.stayAbroadTypesOptions)
const abroadOption = ref(props.answers.abroadOption ?? props.configurations.defaultStayAbroadType)

function triggerSubmit() {
  const page = props.nextForm[0]
  const answers = {
    abroadOption: abroadOption.value
  }

  return { page, answers }
}
</script>